export default {
  // Màn popup chọn ngày khóa sổ
  LockLedgerVoucher: {
    TitlePopup: 'Khóa sổ kỳ kế toán',
    TextAlertPopup: 'Sau khi khóa sổ, không thể sửa các chứng từ được hạch toán kể từ ngày khóa sổ trở về trước.',
    LockLedgerOldDate: 'Ngày khóa sổ cũ',
    LockLedgerNewDate: 'Ngày khóa sổ mới',
  },
  // Bỏ khóa sổ
  UnLockLedgerVoucher: {
    TitlePopup: 'Bỏ khóa sổ',
    LockLedgerOldDate: 'Ngày khóa sổ hiện thời',
    LockLedgerNewDate: 'Đặt ngày khóa sổ về',
    Message: {
      Success: 'Bỏ khoá sổ thành công',
      NotSuccess: 'Bỏ khoá sổ không thành công',
      Warning:
        'Ngày khóa sổ cũ là <span class="color-green">{0}</span>, để sửa lại các chứng từ hạch toán trước ngày {0}, bạn cần thực hiện bỏ khóa sổ. Bạn muốn sửa chứng từ hạch toán từ ngày nào?',
    },
  },
  // Màn xử lý các chứng từ chưa ghi sổ
  ProcessLockLedgerVoucher: {
    TitlePopup: 'Xử lý các chứng từ chưa ghi sổ',
    WriteLedger: 'Ghi sổ',
    ChangeDatePosted: 'Chuyển ngày hạch toán',
    Delete: 'Xóa',
  },
  //
  ResultWriteLedger: {
    TitlePopup: 'Kết quả thực hiện ghi sổ',
  },
};
